import { FormControl } from '@mui/material';
import PaginationItem from '@mui/material/PaginationItem';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowLeftIcon from '../Icons/ArrowLeftIcon';
import ArrowRightIcon from '../Icons/ArrowRightIcon';
import useListPagination from './GridListPagination.hook';
import { GridListPaginationPropsType } from './GridListPagination.types';
import { PAGINATION_PAGE_SIZE_STEPS } from 'basics/constants/common.constant';
import {
  GridListPaginationCountStyle,
  GridListPaginationResultStyle,
  GridListPaginationStyle,
  GridListSelectStyle,
} from 'components/GridListPagination/GridListPagination.style';
import Box from 'yoda-ui/components/Box';
import Select from 'yoda-ui/components/Form/Select';
import MenuItem from 'yoda-ui/components/MenuItem';
import Pagination from 'yoda-ui/components/Pagination';
import { YodaFontSize } from 'yoda-ui/yodaTheme';

const GridListPagination: FC<GridListPaginationPropsType> = ({ pageSize, setPageSize }) => {
  const { page, pageCount, displayedCount, onPageChange, rowsCount, onPageSizeChange } = useListPagination(pageSize, setPageSize);
  const { t } = useTranslation();
  const paginationResultCountLabel = t('maya_list_pagination_result_count_label', { displayedCount, rowsCount });

  return (
    <>
      <FormControl sx={ GridListPaginationStyle }>
        <Select
          value={ pageSize }
          onChange={ onPageSizeChange }
          sx={ GridListSelectStyle }
        >
          {
            PAGINATION_PAGE_SIZE_STEPS.map(
              (pageSizeStep: number) => {
                return <MenuItem key={ pageSizeStep }
                  value={ pageSizeStep }>{ pageSizeStep }</MenuItem>;
              },
            )
          }

        </Select>
      </FormControl>
      <Box sx={ GridListPaginationResultStyle } fontSize={ YodaFontSize.small }>{ paginationResultCountLabel }</Box>
      <Pagination
        sx={ GridListPaginationCountStyle }
        count={ pageCount }
        page={ page + 1 }
        size="small"
        onChange={ onPageChange }
        renderItem={
          (item) => (
            <PaginationItem
              { ...item }
              components={
                {
                  previous: ArrowLeftIcon,
                  next: ArrowRightIcon,
                }
              }
            />
          )
        }
      />
    </>
  );
};

export default GridListPagination;
